import { createContext, useContext, type ReactNode } from "react";
import { toast, type ToastOptions } from "react-toastify";

interface ToastContextType {
  success: (message: string, options?: ToastOptions) => void;
  error: (message: string, options?: ToastOptions) => void;
  info: (message: string, options?: ToastOptions) => void;
  warn: (message: string, options?: ToastOptions) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const success = (message: string, options?: ToastOptions) =>
    toast.success(message, options);
  const error = (message: string, options?: ToastOptions) =>
    toast.error(message, options);
  const info = (message: string, options?: ToastOptions) =>
    toast.info(message, options);
  const warn = (message: string, options?: ToastOptions) =>
    toast.warn(message, options);

  return (
    <ToastContext.Provider value={{ success, error, info, warn }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast deve ser usado dentro de um ToastProvider");
  }
  return context;
};
